<template>
    <v-content>
        <Appbar />
        <v-card
            class="d-flex flex-row mt-8 pa-6"
            height="100%"
            flat
            outlined
            tile
            :color="$vuetify.theme.dark === false ? 'white' : '#1a2d38'"
        >
            <v-container fluid>
                <v-row no-gutters>
                    <v-col :cols="12">
                        <router-view />
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-content>
</template>

<script>
import Appbar from "./Appbar"
export default {
    components: {
        Appbar,
    },
}
</script>
